/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line

import { Drawer, Button, Form, Spin, Input, Icon, message } from 'antd'

import { agentAction } from '../../action/agent'
import { machineAction } from '../../action/machine'

import { MachineAttribute } from '../../business/define'
import { ViewerStyles, EditorStyles } from './styles'

/*
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
}
const buttonItemLayout = {
  wrapperCol: { span: 14, offset: 4 },
}
*/

const FIELDS_LIST = [
  'machine_name',
  'cpu_name',
  'cpu_core_num',
  'memory_total',
  'gpu_name',
  'gpu_memory',
  'gpu_num',
  'disk_ssd_size',
  'disk_hdd_size',
  'net_bus',
  'net_upload_speed',
  'net_download_speed',
  'disk_type',
  'disk_size',
  'os_name',
  'gpu_driver_version',
  'gpu_cuda_version',
]
const ATTRIBUTE_MAPPING: any = {
  machine_name: 'machine_name',
  cpu_name: 'cpu_name',
  cpu_core_num: 'cpu_core_num',
  memory_total: 'memory_total',
  gpu_name: 'gpu_name',
  gpu_memory: 'gpu_memory',
  gpu_num: 'gpu_num',
  disk_ssd_size: 'disk_ssd_size',
  disk_hdd_size: 'disk_hdd_size',
  net_bus: 'net_bus',
  net_upload_speed: 'net_upload_speed',
  net_download_speed: 'net_download_speed',
  disk_type: 'disk_type',
  disk_size: 'disk_size',
  os_name: 'os_name',
  gpu_driver_version: 'gpu_driver_version',
  gpu_cuda_version: 'gpu_cuda_version',
}
const ATTRIBUTE_META: any = {
  machine_name: '型号',
  cpu_name: 'CPU',
  cpu_core_num: '内核',
  memory_total: '内存',
  gpu_name: 'GPU',
  gpu_memory: '显存',
  gpu_num: 'GPU数量',
  disk_ssd_size: 'SSD',
  disk_hdd_size: 'HDD',
  net_bus: '总线传输速度',
  net_upload_speed: '上行带宽',
  net_download_speed: '下行带宽',
  disk_type: '硬盘类型',
  disk_size: '硬盘大小',
  os_name: '操作系统',
  gpu_driver_version: '显卡驱动',
  gpu_cuda_version: '显卡驱动CUDA',
}

const buildMachineAttribute = (rawAttribute: any) => {
  const attribute: any = {}
  Object.keys(ATTRIBUTE_MAPPING).forEach(key => {
    if (rawAttribute[key] && ATTRIBUTE_MAPPING[key]) {
      const val = ATTRIBUTE_MAPPING[key]
      attribute[val] = rawAttribute[key]
    }
  })

  return attribute
}

interface Props {
  text: string
  record: any
  attribute: MachineAttribute
}

const AttributeFormInner = (props: any) => {
  const { getFieldDecorator } = props.form

  const attribute = props['attribute']
  const editAttribute = props['editAttribute']
  const onClickSync = props['onClickSync']
  const onSubmitAttribute = (e: Event) => {
    e.preventDefault()
    props.form.validateFields((err: any, values: any) => {
      if (err) {
        message.warning(err.message)
        console.log('Received values of form: ', values)
      }
      props.onSubmitAttribute(values)
    })
  }

  return <Form layout="vertical" css={EditorStyles['edit-form']} onSubmit={onSubmitAttribute}>
    <Form.Item label="机器编号" css={EditorStyles["edit-label-title"]}>
      <span className="ant-form-text">{props.record['machine_id']}</span>
    </Form.Item>
    {
      FIELDS_LIST.map((item) => {
        return (
          <Form.Item
            key={item}
            label={
              <span css={EditorStyles['edit-label']}>
                <span className="label-title">{ATTRIBUTE_META[item]}:</span>
                <span css={EditorStyles['edit-label-hint']}>{attribute[item] || '未设置'}</span>
              </span>
            }
          >
            <div css={EditorStyles['edit-hint-line']}>
              {
                getFieldDecorator(item, {
                  initialValue: editAttribute[item],
                  rules: [
                    { required: false, message: `请填入正确的${ATTRIBUTE_META[item]}` },
                  ],
                })(
                  <Input placeholder={`Input ${item}`} />
                )
              }
            </div>
          </Form.Item>
        )
      })
    }
    <Form.Item>
      <Button onClick={onClickSync}><Icon type="cloud-sync" /></Button>
      <Button type="primary" htmlType="submit">保存</Button>
    </Form.Item>
  </Form>
}

const AttributeForm = Form.create({ name: 'machine_attribute' })(AttributeFormInner)

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)

  const [attribute, onAttributeChange] = useState<any>(props.attribute)
  const [editAttribute, onEditAttributeChange] = useState<any>(props.attribute)

  const onSyncAgentAttribute = (machineId: any) => {
    onLoadChange(true)
    agentAction.syncAgentMachineAttribute(machineId)
      .then(responseData => {
        onLoadChange(false)
        if (responseData['attributes']) {
          onEditAttributeChange(buildMachineAttribute(responseData['attributes']))
        }
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  const onSubmitAttribute = (formData: any) => {
    machineAction.editMachineAttribute(props.record['machine_id'], formData)
      .then(responseData => {
        onLoadChange(false)
        onAttributeChange(formData)
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  return (
    <div css={EditorStyles['edit-pane']}>
      <Button onClick={onVisibleChange} size="small">{props.text}</Button>
      <Drawer
        title="编辑机器属性"
        width={420}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <Spin spinning={loading}>
            <AttributeForm
              record={props.record}
              attribute={attribute}
              editAttribute={editAttribute}
              onSubmitAttribute={onSubmitAttribute}
              onClickSync={() => {
                onSyncAgentAttribute(props.record['machine_id'])
              }}
            />
          </Spin>
        </div>
      </Drawer>
    </div>
  )
}